import { atom } from 'recoil';
import { ATOMS_KEYS } from '../atom-keys';

export const loaderState = atom<boolean>({
	key: ATOMS_KEYS.LOADERSTATE,
	default: false,
});
